import { ButtonLink } from "Components/Shared/ButtonLink";
import { ForwardArrowIcon } from "Components/Shared/Icons";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

type Props = {
  publicID: string;
};

export const PayTransactionButton = ({ publicID }: Props) => {
  const { t } = useResource();

  return (
    <ButtonLink
      variant="outlined"
      color="info"
      startIcon={<ForwardArrowIcon width={20} height={20} />}
      link={`${appUrl("customer-payment-pay")}/${publicID}`}
      text={t(Resources.Customer.Pay.PayButton)}
    />
  );
};
